import { Grid, LinearProgress, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import type { AiWindow } from "graphql/assistant/queries";
import { FC } from "react";

const useStyles = makeStyles(() => ({
  progressColorSuccess: {
    backgroundColor: '#e0e0e0',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#43a047',
    },
  },
  progressColor: {
    backgroundColor: '#e0e0e0',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#f57c00',
    },
  },
  progressColorDanger: {
    backgroundColor: '#e0e0e0',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#d32f2f',
    }
  }
}));

type limitsProps = {
  mode: string;
  windows: readonly AiWindow[];
}

const Limits: FC<limitsProps> = ({ windows, mode }) => {
  const hourlynumbers = windows?.find(({ period }) => period === "hourly");
  const weeklynumbers = windows?.find(({ period }) => period === "weekly");
  const monthlynumbers = windows?.find(({ period }) => period === "monthly");
  const classes = useStyles();
  const getProgressBarClass = (value: number) => {
    if (value >= 90) return classes.progressColorDanger;
    if (value >= 40) return classes.progressColor;
    return classes.progressColorSuccess;
  };
  const hourlyValue = Math.max(
    hourlynumbers?.prompt_tokens_percent ?? 0,
    hourlynumbers?.completion_tokens_percent ?? 0,
    hourlynumbers?.total_tokens_percent ?? 0,
    hourlynumbers?.requests_percent ?? 0
  );
  const weeklyValue = Math.max(
    weeklynumbers?.prompt_tokens_percent ?? 0,
    weeklynumbers?.completion_tokens_percent ?? 0,
    weeklynumbers?.total_tokens_percent ?? 0,
    weeklynumbers?.requests_percent ?? 0
  );
  const monthlyValue = Math.max(
    monthlynumbers?.prompt_tokens_percent ?? 0,
    monthlynumbers?.completion_tokens_percent ?? 0,
    monthlynumbers?.total_tokens_percent ?? 0,
    monthlynumbers?.requests_percent ?? 0
  );
  return (
    <Grid item>
      <Grid container direction="row">
        <Grid item xs={2} style={{ padding: 1, display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <Typography variant="caption" style={{ fontWeight: 500, fontSize: "0.65rem", lineHeight: 1.2 }}>{mode}</Typography>
        </Grid>
        <Grid item xs style={{ padding: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LinearProgress
            variant="determinate"
            className={getProgressBarClass(hourlyValue)}
            value={hourlyValue}
            style={{ width: "100%", height: 3 }}
          />
        </Grid>
        <Grid item xs style={{ padding: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LinearProgress
            variant="determinate"
            className={getProgressBarClass(weeklyValue)}
            value={weeklyValue}
            style={{ width: "100%", height: 3 }}
          />
        </Grid>
        <Grid item xs style={{ padding: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LinearProgress
            variant="determinate"
            className={getProgressBarClass(monthlyValue)}
            value={monthlyValue}
            style={{ width: "100%", height: 3 }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Limits;